import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function validadorReutilizable(objOpciones: {
 blnPermitirLetras?: boolean;
  blnPermitirNumeros?: boolean;
  blnPermitirEspacios?: boolean;
  blnPermitirAcentos?: boolean;
  blnPermitirPuntos?: boolean;
  blnPermitirCaracteresEspecialesEmpresa?: boolean; // Para nombres de personas morales: -,&´'
  blnPermitirCaracteresEspecialesDireccion?: boolean;  // Para direcciones: .,-_#
  blnPermitirGuionMedio?: boolean; // NUEVO
  intLongitudMinima?: number;
  intLongitudMaxima?: number;
  strCompararConCampo?: string; // Nuevo: Nombre del campo a comparar
  strMensajeComparacion?: string;  // Nuevo: Mensaje de error si no coincide
  blnEsCURP?: boolean;
}): ValidatorFn {
  const {
    blnPermitirLetras = true,
    blnPermitirNumeros = false,
    blnPermitirEspacios = true,
    blnPermitirAcentos = false,
    blnPermitirPuntos = false,
    blnPermitirCaracteresEspecialesEmpresa = false,
    blnPermitirCaracteresEspecialesDireccion = false,
    blnPermitirGuionMedio = false, // NUEVO
    intLongitudMinima = 3,
    intLongitudMaxima = 100,
    strCompararConCampo = '',
    strMensajeComparacion = 'Los valores deben coincidir.',
    blnEsCURP = false,
  } = objOpciones;
  return (objControl: AbstractControl): ValidationErrors | null => {
    if (!objControl.value) {
      return { required: "El campo no puede estar vacío." };
    }
    let strValor = objControl.value.toString().toUpperCase();
    const strValorOriginal = strValor;
    // Si el valor cambió (ejemplo: estaba en minúsculas), actualiza el control
    if (strValor !== strValorOriginal) {
      objControl.setValue(strValor, { emitEvent: false });
    }
    // 1. Definir caracteres permitidos
    let strPatronRegex = '^';
    const arrCaracteresPermitidos: string[] = [];
    if (blnPermitirLetras) arrCaracteresPermitidos.push('A-ZÑ');
    if (blnPermitirAcentos) arrCaracteresPermitidos.push('À-ÿ');
    if (blnPermitirNumeros) arrCaracteresPermitidos.push('0-9');
    if (blnPermitirEspacios) arrCaracteresPermitidos.push('\\s');
    if (blnPermitirPuntos) arrCaracteresPermitidos.push('\\.');
    // Caracteres especiales para negocios
    if (blnPermitirCaracteresEspecialesEmpresa) {
      arrCaracteresPermitidos.push('\\-\\,\\&\\´\\\'');
    }
    // Caracteres especiales para direcciones
    if (blnPermitirCaracteresEspecialesDireccion) {
      arrCaracteresPermitidos.push('\\.\\,\\-\\_\\#');
    }

    if (blnPermitirGuionMedio) {
      arrCaracteresPermitidos.push('\\-');
    }
    if (blnPermitirPuntos) {
      strValor = strValor.replace(/\.{2,}/g, '.');
    }
    strPatronRegex += `[${arrCaracteresPermitidos.join('')}]+$`;
    const objRegex = new RegExp(strPatronRegex, 'g');
    // 2. Limpiar caracteres no permitidos
      strValor = strValor.replace(new RegExp(`[^${arrCaracteresPermitidos.join('')}]`, 'g'), '');

    // 3. Aplicar límites de caracteres consecutivos
    // Espacios (si están permitidos)
    if (blnPermitirEspacios) {
      strValor = strValor.replace(/\s{2,}/g, ' ');
    }
    // Limitar caracteres especiales consecutivos
    const arrCaracteresEspecialesALimitar: string[] = [];
    if (blnPermitirCaracteresEspecialesEmpresa) arrCaracteresEspecialesALimitar.push('-', ',', '&', '´', "'");
    if (blnPermitirCaracteresEspecialesDireccion) arrCaracteresEspecialesALimitar.push('.', ',', '-', '_', '#');
    if (blnPermitirGuionMedio) arrCaracteresEspecialesALimitar.push('-');
    // Eliminar duplicados y aplicar límite
    Array.from(new Set(arrCaracteresEspecialesALimitar)).forEach(strCaracter => {
      const objRegexEspecial = new RegExp(`\\${strCaracter}{2,}`, 'g');
      strValor = strValor.replace(objRegexEspecial, strCaracter);
    });
    // 4. Eliminar espacios al inicio
    strValor = strValor.replace(/^\s+/, '');
    // Actualizar control si hubo cambios
    if (strValor !== strValorOriginal) {
      objControl.setValue(strValor, { emitEvent: false });
      objControl.updateValueAndValidity({ emitEvent: false });
    }

    // Validación de longitud mínima
    const intLongitudValidacion = blnPermitirEspacios
      ? strValor.replace(/\s/g, '').length
      : strValor.length;
    if (intLongitudValidacion < intLongitudMinima) {
      return {
        longitudMinima: {
          requiredLength: intLongitudMinima,
          actualLength: intLongitudValidacion,
          message: `Debe tener al menos ${intLongitudMinima} caracteres válidos.`
        }
      };
    }
    if (intLongitudValidacion > intLongitudMaxima) {
      strValor = strValor.substring(0, intLongitudMaxima);
      objControl.setValue(strValor, { emitEvent: false });
    }
    // Validación CURP
    if (blnEsCURP) {

      const PATRON_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
      if (!PATRON_CURP.test(strValor)) {
        return { pattern: "La CURP no tiene un formato válido." };
      }
    }
    // Validación comparación cruzada
    if (strCompararConCampo && objControl.parent) {
      const objControlComparacion = objControl.parent.get(strCompararConCampo);
      if (objControlComparacion && objControlComparacion.value) {
        const strValorComparacion = objControlComparacion.value.toString().substring(0, 10).toUpperCase();
        const strValorActual = strValor.substring(0, 10).toUpperCase();
        if (strValorActual !== strValorComparacion) {
          return { noMatch: strMensajeComparacion };
        }
      }
    }

    return null;
  };
}

